import { render } from "./Proposta.vue?vue&type=template&id=07e00035&scoped=true"
import script from "./Proposta.vue?vue&type=script&lang=js"
export * from "./Proposta.vue?vue&type=script&lang=js"

import "./Proposta.vue?vue&type=style&index=0&id=07e00035&lang=css"
import "./Proposta.vue?vue&type=style&index=1&id=07e00035&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e00035"]])

export default __exports__